import { useMemo, useCallback } from "react";
import Dropdown from "./Dropdown";

const DropDownType = ({
  value,
  onChange,
  options = [],
  optionsValue = [],
  disabled = false,
}) => {
  const mappedOptions = useMemo(() => {
    if (
      Array.isArray(options) &&
      options.length > 0 &&
      typeof options[0] === "object" &&
      options[0] !== null &&
      "label" in options[0] &&
      "value" in options[0]
    ) {
      return options;
    }

    const len = Math.min(options.length, optionsValue.length);
    return Array.from({ length: len }).map((_, idx) => ({
      label: options[idx],
      value: optionsValue[idx],
    }));
  }, [options, optionsValue]);

  const handleChange = useCallback(
    (arg) => {
      const nextValue = arg?.target ? arg.target.value : arg;
      onChange?.(nextValue);
    },
    [onChange],
  );

  return (
    <Dropdown
      variant="select"
      id="type-select"
      value={value}
      onChange={handleChange}
      options={mappedOptions}
      placeholderKey="dropdown.type"
      disabled={disabled}
    />
  );
};

export default DropDownType;
